import { Modal } from "@shopify/polaris";

import { useSurveyForm } from "../hooks/useSurveyForm";
import { SurveyQuestionFields } from "./SurveyQuestionFields";

import { t } from "../lib/i18n";

type Props = {
  open: boolean;
  onAnswered: () => void;
};

/**
 * 課金直前の**飛ばせない**アンケート関門（Plans 画面専用）。
 *
 * [[InstallSurveyModal]] は ×/ESC/背景で閉じられる非ブロッキング表示だが、これは
 * SPA が有料プランで `POST /billing/subscribe` を呼ぶ**直前**にだけ挟む「答えるまで
 * 進めない」版（決定：Free プランの選択はこの関門の対象外＝呼び出し元 `Plans.tsx` の
 * `handleSelectPlan` が `planCode !== "free"` のときだけ `pendingPlanCode` を立てる）。
 * 有料プランは承認後に戻ってくる瞬間があるが、Free は `/subscribe` が Shopify 往復
 * なしでその場 `ShopSubscription(ACTIVE)` を同期コミットする（`billing.py:65`）ため
 * 承認後や `/billing/sync` 側には置けない＝有料プランに関してはこの呼び出し直前が
 * 唯一の関門ポイント。
 *
 * Polaris の Modal に「閉じるボタンを消す」オプションが無いため、×ボタン自体は残るが
 * `onClose` を素通り（何もしない）にして `open` を親のみが制御することで実質無効化する。
 */
export function BillingSurveyGateModal({ open, onAnswered }: Props) {
  const form = useSurveyForm({ enabled: open, onAnswered });

  return (
    <Modal
      open={open}
      onClose={() => {}}
      title={t("プランを選ぶ前に、UreyukiBox をどこで知りましたか？")}
      primaryAction={{
        content: t("送信して続ける"),
        disabled: !form.canSubmit,
        loading: form.isPending,
        onAction: form.submit,
      }}
    >
      <Modal.Section>
        <SurveyQuestionFields
          source={form.source}
          onSourceChange={form.setSource}
          showsPartnerPicker={form.showsPartnerPicker}
          showsOtherSourceInput={form.showsOtherSourceInput}
          isOtherPartner={form.isOtherPartner}
          partner={form.partner}
          onPartnerChange={form.setPartner}
          partnerOptions={form.partnerOptions}
          otherReferrer={form.otherReferrer}
          onOtherReferrerChange={form.setOtherReferrer}
          isError={form.isError}
        />
      </Modal.Section>
    </Modal>
  );
}
